import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home'
import Ablauf from '../views/Ablauf'
import Infos from '../views/Infos'
import Bilder from '../views/Bilder'


Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: Home,
    meta: { order: 0 }
  },
  {
    path: '/ablauf',
    name: 'ablauf',
    component: Ablauf,
    meta: { order: 1 }
  },
  {
    path: '/infos',
    name: 'infos',
    component: Infos,
    meta: { order: 2 }
  },
  {
    path: '/bilder',
    name: 'bilder',
    component: Bilder
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
